import React, { useRef, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export function ChatInput({ value, onChange, onSend, disabled, placeholder }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.style.height = "auto";
      ref.current.style.height = Math.min(ref.current.scrollHeight, 200) + "px";
    }
  }, [value]);

  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!disabled && value.trim()) onSend();
    }
  };

  return (
    <form
      data-testid="chat-input-form"
      onSubmit={(e) => {
        e.preventDefault();
        if (!disabled && value.trim()) onSend();
      }}
      className="w-full"
    >
      <div className="max-w-3xl mx-auto bg-card/95 backdrop-blur-xl border border-border/70 rounded-3xl shadow-glass p-2 flex items-end gap-2">
        <textarea
          ref={ref}
          data-testid="chat-input"
          rows={1}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={placeholder || "Ask anything..."}
          className="flex-1 resize-none bg-transparent outline-none px-3 py-2 text-[15px] max-h-[200px] thin-scroll"
          disabled={disabled}
        />
        <button
          type="submit"
          data-testid="chat-send-button"
          disabled={disabled || !value.trim()}
          aria-label="Send message"
          className="h-10 w-10 shrink-0 rounded-full bg-brand text-brand-foreground flex items-center justify-center hover:scale-105 transition-transform disabled:opacity-40 disabled:hover:scale-100 shadow-[0_4px_14px_-4px_hsl(var(--brand-accent)/0.6)]"
        >
          <ArrowUp size={18} strokeWidth={2} />
        </button>
      </div>
      <div className="text-[11px] text-muted-foreground text-center mt-2">
        Enter to send · Shift+Enter for newline
      </div>
    </form>
  );
}
